import React from 'react';

const inspectionData = {
  title: "We see what others miss",
  intro: "A home inspection is the most important step of Home Buying process. Buying a new home is probably the biggest investment you’ll ever make, and it’s a decision that will affect you for years to come. The process can be extremely stressful and confusing. And of course, there is always considerable risk involved when making such a large purchase decision. A professional inspection will significantly reduce your risk and help make the entire home-buying process easier and less stressful.",
  trust: {
    headline: "Believe in the best",
    services: "For your Residential, Commercial, Mold and Environmental inspection needs",
    experience: "We are qualified professionals (Registered Inspectors) with over 18 years of experience, highly skilled and trained."
  },
  reportDetails: "Our reports are detailed, unbiased, and easy to read and understand. We provide you electronic inspection report with pictures and thoroughly explain the report findings at the time of inspection. In addition to reporting any deficiencies or potential failures, our inspections include maintenance tips and other educational information."
};

const HomeInspectionInfo = () => {
  return (
    <div className="inspection-section">
      <div className='container'>
        <div className='inner-content'>
            <h2>{inspectionData.title}</h2>
      <p>{inspectionData.intro}</p>

      <h2>{inspectionData.trust.headline}</h2>
      <p>{inspectionData.trust.services}</p>
      <p>{inspectionData.trust.experience}</p>

      <h2>We are Registered Home Inspectors, Well Trained and Insured</h2>
      
      <p>{inspectionData.reportDetails}</p>
        </div>
      </div>
    </div>
  );
};

export default HomeInspectionInfo;
